<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      

      <!-- 母题讲解练习--作业 -->
      <div class="MobelBox workExamBox" v-if="workExamType">
        <p class="add-title">母题讲解练习</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="week-date">
          <p :class="weekIndex==item.week?'select':''" v-for="(item,index) in workExamList" :key="index" @click="weekSub(item)">第{{item.week}}周</p>
          <span v-show="weekIndex==item.week" v-for="(item,index) in workExamList" :key="index">{{item.week_name}}</span>
        </div>
        <div class="write-txt" v-for="(item,index) in workExamList" :key="index" v-show="weekIndex==(index+1)">
          <p class="write-title">选择母题：</p>
          <div class="write-text">
            <div class="week-list" v-for="(ele,num) in item.practice" :key="num">
              <p class="week-txt" :class="practiceIndex==num?'select':''" @click="practiceSub(num)">{{ele.title}}</p>
            </div>
          </div>
        </div>
        
        <div class="write-txt">
          <p class="write-title">原视频：</p>
          <div class="write-text">
            <video :src="'https://pic.bi-rong.com/'+item.video" v-for="(item,index) in videoList" :key="index"></video>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">学生讲解内容：</p>
          <div class="write-text">
            <button class="btn btn-play" @click="audioPlay('','topic')">{{audioTxt}}</button>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">AI点评：</p>
          <div class="write-text">
            <textarea v-model="ai_comment" disabled></textarea>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">老师点评：</p>
          <div class="write-text">
            <textarea v-model="teacher_comment"></textarea>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="workExamSub('1')">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <!-- 母题讲解练习编辑--作业 -->
      <div class="MobelBox workBuildBox" v-if="workBuildType">
        <p class="add-title">习题刻意练习</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="week-date">
          <p :class="weekIndex==item.week?'select':''" v-for="(item,index) in workExamList" :key="index" @click="weekSub(item,'build')">第{{item.week}}周</p>
        </div>
        <div class="write-txt" v-for="(item,index) in workExamList" :key="item.week" v-show="weekIndex==(index+1)">
          <p class="write-title">选择练习题：</p>
          <!-- <div class="write-text">
            <div class="week-list" v-for="(ele,num) in item.practice" :key="ele.key">
              <p class="week-txt" :class="practiceIndex==num?'select':''" @click="practiceSub(num,'build')">{{ele.title}}</p>
            </div>
            <div class="week-list" v-for="(ele,num) in item.practice" :key="num">
              <p class="week-txt" v-for="(i,k) in ele.big_topic" :key="i.key" :class="topicIndex==k?'topicSelect':''" @click="topicSub(k,'build')">第{{(k+1)}}题</p>
            </div>
          </div> -->
          <div class="big-topic-list">
            <p v-for="(ele,num) in item.practice" :key="(num+1)" :class="practiceIndex==num?'select':''" @click="practiceSub(num,'build')">
              {{ele.title}}
            </p>
            <div class="topic-list" v-for="(ele,num) in item.practice" :key="(num+1)" v-show="practiceIndex==num">
              <p v-for="(i,k) in ele.big_topic" :key="i.utid" :class="topicIndex==k?'select':''" @click="topicSub(k,'build')">第{{(k+1)}}题</p>
            </div>
          </div>
        </div>

        <div class="write-txt">
            <p class="write-title"><span>*</span>文章：</p>
            <div class="write-text">
              <!-- <textarea placeholder="请输入文章" v-model="workBuildData.content" disabled></textarea> -->
              <div class="write-content" placeholder="请输入文章" v-html="workBuildData.content" disabled></div>
            </div>
          </div>

        <div style="width: 100%;" v-for="(item,index) in workBuildData.topic" :key="item.rtid">
          <div class="write-txt">
            <p class="write-title"><span>*</span>题干：</p>
            <div class="write-text">
              <textarea placeholder="请输入题干" v-model="item.topic" disabled></textarea>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title"><span>*</span>学生答案：</p>
            <div class="write-text">
              <!-- <textarea placeholder="" v-model="item.my_answer" disabled></textarea> -->
              <div class="write-content" v-html="item.my_answer" disabled></div>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title"><span>*</span>AI点评：</p>
            <div class="write-text">
              <div class="write-content" v-html="item.ai_comment" disabled></div>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title"><span>*</span>AI批改：</p>
            <div class="write-text">
              <p :class="item.ai_judge==1?'txt1':item.ai_judge==2?'txt2':''">{{item.ai_judge==0?'未知':item.ai_judge == 1 ? '正确' :'错误'}}</p>
            </div>
          </div>

          <div class="write-txt"  v-loading="loading" :element-loading-text="loadTxt">
            <p class="write-title"><span>*</span>人工纠错：</p>
            <div class="write-text">
              <p class="answer-type" @click="judgeSub(item,1)" :class="item.people_judge==1?'select':''">正确</p>
              <p class="answer-type" @click="judgeSub(item,2)" :class="item.people_judge==2?'select':''">错误</p>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title"><span>*</span>原答案：</p>
            <div class="write-text">
              <!-- <textarea placeholder="" v-model="item.answer" disabled></textarea> -->
              <div class="write-content" v-html="item.answer" disabled></div>
            </div>
          </div>
        </div>

        <div class="write-txt">
          <!-- <p class="write-title"><span>*</span>AI错因分析：</p> -->
          <p class="write-title"><span>*</span>AI综合点评：</p>
          <div class="write-text">
            <textarea placeholder="" v-model="workBuildData.ai_error_analysis" disabled></textarea>
          </div>
        </div>

        <!-- <div class="write-txt">
          <p class="write-title"><span>*</span>AI练习题讲解：</p>
          <div class="write-text">
            <textarea placeholder="" v-model="workBuildData.explain" disabled></textarea>
          </div>
        </div> -->

        <div class="write-txt">
          <p class="write-title"><span>*</span>老师点评：</p>
          <div class="write-text">
            <textarea placeholder="请输入老师点评" v-model="workBuildData.teacher_comment"></textarea>
          </div>
        </div>

        <div class="WrongQuestion" style="display: block;">
          <div class="wrong-item" v-for="(item,index) in workBuildData.error_list" :key="index">
            <p class="wrong-title">第{{(index+1)}}次错题讲解</p>
            <div class="write-txt">
              <p class="write-title"><span>*</span>学生复盘讲解：</p>
              <div class="write-text">
                <button class="btn btn-play" @click="audioPlay(item,'student')">{{item.audioTxt}}</button>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title"><span>*</span>AI点评：</p>
              <div class="write-text">
                <textarea placeholder="" v-model="item.ai_comment" disabled></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title"><span>*</span>解题步骤：</p>
          <div class="write-text">
            <textarea placeholder="请输入解题步骤" v-model="workBuildData.explain"></textarea>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="workExamSub(2)">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <!-- 作业 -->
      <div class="organiza-txt workBox" v-else>
        <div class="organiza-title clear">
          <div class="searchBox clear">
            <div class="search-item">
              <p>学员姓名：</p>
              <input type="text" placeholder="请输入要搜索的学员姓名" v-model="obj.name">
            </div>
            <div class="search-item">
              <p>手机号：</p>
              <input type="text" placeholder="请输入要搜索的手机号" v-model="obj.mobile">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">作业列表</div>
          <div class="titleList">
            <p v-for="item in workList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.sex==1?'男':'女'">{{item.sex==1?'男':'女'}}</p>
              <p :title="item.province + '/' + item.city">{{item.province}} / {{item.city}}</p>
              <p :title="item.school">{{item.school}}</p>
              <p :title="item.grade">{{item.grade}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.deadline">{{item.deadline}}</p>
              <p :title="item.video_rate">{{item.video_rate}}</p>
              <p :title="item.topic_rate">{{item.topic_rate}}</p>
              <p>
                <button title="母题讲解练习" class="btn btn-revise" @click="buildShow(item)">母题讲解练习</button>
                <button title="习题刻意练习" class="btn btn-remove" @click="examShow(item)">习题刻意练习</button>
                <button title="练习报告" class="btn btn-remove" @click="resultShow(item)">练习报告</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>

    <audio :src="'https://pic.bi-rong.com/'+audioUrl" style="display: none;" ref="audio" @ended="audoEnd"></audio>
  </div>
</template>

<script>
import { addTeacherJudge,getReadStudentVideo ,getAiRecognition ,getTypeLabelList ,saveRead ,updateReadStatus ,delTopic,getStudentList ,getReadStudentTopic,getReadStudentList ,addTeacherComment } from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'8',
      childrenID:'8-1',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'标题'},
        {id:3,title:'学员数量'},
        {id:4,title:'视频课数量'},
        {id:5,title:'练习题数量'},
        {id:6,title:'开始时间'},
        {id:7,title:'结束时间'},
        {id:8,title:'状态'},
        {id:9,title:'创建时间'},
        {id:10,title:'操作'},
      ],
      studentTitle:[
        {id:1,title:''},
        {id:2,title:'姓名'},
        {id:3,title:'手机号码'},
      ],
      dataList:[],
      addType:'',
      listObj:{
        page:1,
        rows:10
      },
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10,
        id:''
      },
      addObj:{},
      totalPage:0,
      listTotalPage:0,
      removeID:'',
      url:'',
      statusList:[
        {id:0,title:'否',value:0},
        {id:1,title:'是',value:1},
      ],
      loading:false,
      loadTxt:'',
      listType:false,
      explainType:false,
      IntentionallyType:false,
      buildType:false,
      workType:false,
      workExamType:false,
      workList:[
        {id:1,title:'序号'},
        {id:2,title:'姓名'},
        {id:3,title:'性别'},
        {id:4,title:'地区'},
        {id:5,title:'学校'},
        {id:6,title:'年级'},
        {id:7,title:'手机号'},
        {id:8,title:'有效截止时间'},
        {id:9,title:'母题练习完成率'},
        {id:10,title:'习题练习完成率'},
        {id:11,title:'操作'},
      ],
      workBuildType:false,
      weekIndex:1,
      videoList:[],
      videoIndex:0,
      practiceIndex:0,
      topicIndex:0,
      audioUrl:'',
      workExamList:[],
      workExamObj:{},
      ai_comment:"",
      teacher_comment:"",
      workBuildData:{},
      audioTxt:'播放语音'
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      this.obj.id = this.$route.query.id;
      try {
        const response = await getReadStudentList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async switchChange(e){
      var that = this;
      console.log(e)
      var obj = {
        id:e.id,
        status:e.status==false?0:1,
      };
      try {
        const response = await updateReadStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    async addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await getReadStudentVideo({rmid:this.obj.id,user_id:e.user_id},this.token);
        if(response.code == 200){
          that.workExamType = true;
          that.workExamList = response.data;
          that.weekIndex = response.data[0].week;
          that.practiceIndex = 0;
          that.videoIndex = 0;
          that.videoList = response.data[(that.weekIndex-1)].practice[that.practiceIndex].video;
          that.audioUrl = response.data[(that.weekIndex-1)].practice[that.practiceIndex].audio;
          that.ai_comment = response.data[(that.weekIndex-1)].practice[that.practiceIndex].ai_comment;
          that.teacher_comment = response.data[(that.weekIndex-1)].practice[that.practiceIndex].teacher_comment;
          console.log(that.workExamList,'list')
          // that.addObj.id = e.id;
          // that.addType = 'edit';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    async getLabelDetail(i,type){
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:that.value1,
          table_type:1
        };
        if(type == 'topic'){
          obj.one_id = this.topicValue1;
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id:this.value2,
          table_type:1
        }
        if(type == 'topic'){
          obj.two_id = that.topicValue2;
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
              that.articleTwoList.forEach(function(item,index){
                if(item.title == that.addObj.material_label_two){
                  that.value2 = item.id;
                }
              })
              that.getLabelDetail(3,'article');
            } else {
              that.topicTwoList = response.data;
              that.topicTwoList.forEach(function(item,index){
                if(item.title == that.addObj.topic_label_two){
                  that.topicValue2 = item.id;
                }
              })
              that.getLabelDetail(3,'topic');
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
              that.articleThreeList.forEach(function(item,index){
                if(item.title == that.addObj.material_label_three){
                  that.value3 = item.id;
                }
              })
            } else {
              that.topicThreeList = response.data;
              that.topicThreeList.forEach(function(item,index){
                if(item.title == that.addObj.topic_label_three){
                  that.topicValue3 = item.id;
                }
              })
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      this.removeID = e.tmid;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delTopic({tmid:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请填写标题！');
        return false;
      }
      if(this.addObj.begin_date == ''){
        that.$message('请选择开始时间！');
        return false;
      }
      if(this.addObj.end_date == ''){
        that.$message('请选择结束时间！');
        return false;
      }
      console.log(this.addObj,'addObj');
      try {
        const response = await saveRead(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.weekIndex = 1;
      this.practiceIndex = 0;
      this.videoList = [];
      this.videoIndex=0;
      this.audioUrl='';
      this.workBuildData = {};
      this.workExamType = false;
      this.workExamList = [];
      this.workBuildType = false;
      this.workExamObj={};
      this.ai_comment="";
      this.teacher_comment="";
    },

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    beforeUpload(){
      this.loading = true;
    }, 
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.loading = false;
        that.getList();
      } else {
        that.loading = false;
        that.$message(response.msg);
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj={
        province:'',
        city:'',
        period:'',
        content:'',
        material_label_one:'',
        material_label_two:'',
        material_label_three:'',
        topic:[
          {
            topic:'',
            topic_type:'',
            answer:'',
            topic_label_one:'',
            topic_label_two:'',
            topic_label_three:'',
          }
        ]
      };
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },

    async aiSub(type,i,e){
      var that = this;
      var obj = {};
      if(this.addObj.content == ''){
        that.$message('请填写文章内容！');
        return false;
      }
      if(type=='article'){
        obj = {
          type:1,
          level:i,
          content:this.addObj.content,
        };
        if(i == 2){
          that.addObj.material_label_two = '生成中...'
          obj.material_label_one = that.addObj.material_label_one ? that.addObj.material_label_one : this.value1
        }
        if(i == 3){
          that.addObj.material_label_three = '生成中...'
          obj.material_label_two = that.addObj.material_label_two ? that.addObj.material_label_two : this.value2
        }
        if(i == 1){
          that.addObj.material_label_one = '生成中...'
          that.getTypeList(i,'article')
        }

      } else if(type == 'topic'){
        try {
          that.addObj.topic.forEach(function(item,index){
            if(item.topic == ''){
                that.$message('题目'+(index+1)+'题干还未填写');
                throw new Error("EndIterative");
            } else {
                // console.log(ele,num);
            }
          })
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
        obj = {
          type:2,
          level:i,
          content:this.addObj.content,
          topic:e.topic
        };
        if(i == 2){
          e.topic_label_two = '生成中...'
          obj.topic_label_one = e.topic_label_one ? e.topic_label_one : this.topicValue1;
        }
        if(i == 3){
          e.topic_label_three = '生成中...'
          obj.topic_label_two = e.topic_label_two ? e.topic_label_two : this.topicValue2;
        }
        if(i == 1){
          e.topic_label_one = '生成中...'
          that.getTypeList(i,'topic')
        }
      } else if(type == 'topicType'){
        obj = {
          type:3,
          topic:e.topic,
        }
        e.topic_type = '生成中...'
      };
      this.loading = true;
      this.loadTxt = '请稍后...'
      try {
        const response = await getAiRecognition(obj,this.token);
        if(response.code == 200){
          if(type == 'article'){
            if(i == 1){
              that.addObj.material_label_one = response.data.answer;
              that.value1 = '';
            } else if(i == 2){
              that.addObj.material_label_two = response.data.answer;
              that.value2 = '';
            } else if(i == 3){
              that.addObj.material_label_three = response.data.answer;
              that.value3 = '';
            } 
          } else if(type == 'topic'){
            if(i == 1){
              e.topic_label_one = response.data.answer;
              that.topicValue1 = '';
            } else if(i == 2){
              e.topic_label_two = response.data.answer;
              that.topicValue2 = '';
            } else if(i == 3){
              e.topic_label_three = response.data.answer;
              that.topicValue3 = '';
            } 
          } else if(type == 'topicType'){
            e.topic_type = response.data.answer;
          };
          that.$forceUpdate();
          that.loading = false;
        } else {
          that.$message(response.msg);
          that.loading = false;
        }
      } catch (error) {
        that.$message(error);
        that.loading = false;
      }
    },

    async getTypeList(i,type){
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:that.value1,
          table_type:1
        };
        if(type == 'topic'){
          obj.one_id = this.topicValue1;
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id:this.value2,
          table_type:1
        }
        if(type == 'topic'){
          obj.two_id = that.topicValue2;
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 1){
            if(type == 'article'){
              that.articleOneList = response.data;
            } else {
              that.topicOneList = response.data;
            }
          }
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
            } else {
              that.topicTwoList = response.data;
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
            } else {
              that.topicThreeList = response.data;
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    articleLabel(type,e,topic,num){
      var that = this;
      if(type == 1){
        if(topic == 'topic'){
          that.getTypeList(2,'topic');
          that.topicOneList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_one = item.title
            }
          });
          that.addObj.topic[num].topic_label_two = '';
          that.topicValue2 = '';
          that.addObj.topic[num].topic_label_three = '';
          that.topicValue3 = '';
        } else {
          that.getTypeList(2,'article');
          that.addObj.material_label_two = '';
          that.value2 = '';
          that.addObj.material_label_three = '';
          that.value3 = '';
          that.articleOneList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_one = item.title
            }
          });
          
        }
      } else if(type == 2){
        if(topic == 'topic'){
          that.getTypeList(3,'topic')
          that.topicTwoList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_two = item.title
            }
          });
          that.addObj.topic[num].topic_label_three = '';
          that.topicValue3 = '';
        } else {
          that.getTypeList(3,'article')
          that.articleTwoList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_two = item.title
            }
          });
          that.addObj.material_label_three = '';
          that.value3 = '';
        }
      } else if(type == 3){
        if(topic == 'topic'){
          that.topicThreeList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_three = item.title
            }
          });
        } else {
          that.articleThreeList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_three = item.title
            }
          });
        }
      }
    },

    addTopic(){
      var list = {
        topic:'',
        topic_type:'',
        answer:'',
        topic_label_one:'',
        topic_label_two:'',
        topic_label_three:'',
      }
      this.addObj.topic.push(list);
    },

    removeTopic(e,i){
      this.addObj.topic.splice(i,1)
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList,index,type,num) {
      var that = this;
      if(type == 'ph_headpic'){
        that.levelObj.level[index].ph_headpic = response.key;
      } else if(type == 'user_banner'){
        that.examObj.level[index].image_videos[num].image = response.key;
        console.log(type,index,num,that.examObj.level,'==type==')
        // that.$forceUpdate();
      } else {
        that.addObj.image = response.key;
      }
      that.loading = false;
      that.uploadObj.key = "";
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
    },

    async chooseStudent(){
      var that = this;      
      try {
        const response = await getStudentList(this.listObj,this.token);
        if(response.code == 200){
          if(that.addObj.student_ids){

          } else {
            response.data.list.forEach(function(item,index){
              item.checked = false;
            })
            that.studentList = response.data.list;
            that.addObj.student_ids = [];
          };
          that.listType = true;
          that.addType = '';
          that.listTotalPage = response.data.totalPage;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    studentSub(){
      var that = this;
      console.log(this.studentList);
      this.studentList.forEach(function(item,index){
        if(item.checked){
          that.addObj.student_ids.push(item.id)
        }
      });
      this.addType = 'add';
      this.listType = false;
    },

    explainShow(e){
      this.$router.push('/explain?id='+e.id);
    },

    exercisesShow(e){
      this.$router.push('/exercises?id='+e.id);
    },


    weekSub(e,type){
      var that = this;
      this.weekIndex = e.week;
      this.practiceIndex = 0;
      this.topicIndex = 0;
      if(type == 'build'){
        that.workBuildData = {
          content:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].content,
          topic:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].topic,
          ai_error_analysis:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].ai_error_analysis,
          explain:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].explain,
          teacher_comment:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].teacher_comment,
          error_list:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].error_list,
        };
        that.practiceSub(0,'build')
        return false;
      }
      this.videoList = this.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].video;
      this.audioUrl = this.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].audio;
    },

    practiceSub(num,type){
      var that = this;
      this.practiceIndex = num;
      this.topicIndex = 0;
      if(type == 'build'){
        that.workBuildData = {
          content:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].content,
          topic:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].topic,
          ai_error_analysis:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].ai_error_analysis,
          explain:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].explain,
          teacher_comment:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].teacher_comment,
          error_list:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].error_list,
        };
        that.topicSub(0,'build')
        return false;
      }
      this.videoList = this.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].video;
      this.audioUrl = this.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].audio;
    },

    topicSub(k,type){
      var that = this;
      this.topicIndex = k;
      if(type == 'build'){
        that.workBuildData = {
          content:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].content,
          topic:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].topic,
          ai_error_analysis:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].ai_error_analysis,
          explain:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].explain,
          teacher_comment:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].teacher_comment,
          error_list:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].error_list,
        };
        return false;
      }
      this.videoList = this.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].video;
      this.audioUrl = this.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].audio;
    },

    async judgeSub(e,type){
      var that = this;
      this.loading = true;
      this.loadTxt = '请稍后'
      try {
        const response = await addTeacherJudge({utlid:e.utlid,people_judge:type},this.token);
        if(response.code == 200){
          e.people_judge = type;
          if(response.data.ai_error_analysis == null){

          } else {
            that.workBuildData.ai_error_analysis = response.data.ai_error_analysis;
          }
        } else {
          that.$message(response.msg);
        }
        that.loading = false;
        that.loadTxt = ''
      } catch (error) {
        that.loading = false;
        that.$message(error);
      }
    },

    audioPlay(e,type){
      var that = this;
      if(type == 'student'){
        if(e.audio == ''){
          that.$message('暂无语音');
          return false;
        }
        that.$refs.audio.src = 'https://pic.bi-rong.com/' + e.audio;
        that.$refs.audio.play();
        that.audioObj = e;
        that.workBuildData.error_list.forEach(function(item,index){
          if(item.utelid == that.audioObj.utelid){
            item.audioTxt = '播放中'
          } else {
            item.audioTxt = '播放语音'
          }
        })
        console.log(e,'==e==')
        that.$forceUpdate()
        return false;
      }
      console.log(this.audioUrl,'this.$refs.audio.src')
      if(this.audioUrl == '' || this.audioUrl == null){
        that.$message('暂无语音');
        return false;
      }
      this.$refs.audio.play();
      this.audioTxt = '播放中';
    },

    audoEnd(e){
      var that = this;
      this.audioTxt = '播放语音';
      if(this.workBuildData.error_list){
        this.workBuildData.error_list.forEach(function(item,index){
          if(item.utelid == that.audioObj.utelid){
            item.audioTxt = '播放语音'
          }
        })
      }
      that.$forceUpdate()
      console.log(this.audioTxt,'结束');
    },

    async workExamSub(type){
      var that = this;  
      var obj = {};
      if(type == 1){
        obj = {
          type:type,
          uvid:this.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].uvid,
          teacher_comment:that.teacher_comment
        }
      } else {
        obj = {
          type:type,
          utid:this.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].utid,
          teacher_comment:that.workBuildData.teacher_comment
        }
      }
      
      try {
        const response = await addTeacherComment(obj,this.token);
        if(response.code == 200){
          window.location.reload();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async examShow(e){
      var that = this;      
      try {
        const response = await getReadStudentTopic({rmid:this.obj.id,user_id:e.user_id},this.token);
        if(response.code == 200){
          that.workBuildType = true;
          that.workExamList = response.data;
          that.practiceIndex = 0;
          that.topicIndex = 0;
          that.workBuildData = {
            content:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].content,
            topic:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].topic,
            ai_error_analysis:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].ai_error_analysis,
            explain:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].explain,
            teacher_comment:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].teacher_comment,
            error_list:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].error_list,
          }
          











          // that.practiceIndex = 0;
          // that.videoIndex = 0;
          that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].big_topic[that.topicIndex].error_list.forEach(function(item,index){
            item.audioTxt = '播放语音'
          })
          // that.workBuildData = {
          //   content:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].content,
          //   topic:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].topic,
          //   ai_error_analysis:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].ai_error_analysis,
          //   explain:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].explain,
          //   teacher_comment:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].teacher_comment,
          //   error_list:that.workExamList[(that.weekIndex-1)].practice[that.practiceIndex].error_list,
          // }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    resultShow(e){
      this.$router.push('/marketResult?rmid='+this.obj.id + '&user_id='+e.user_id);
    }
  }

 

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 10 );
  }

  /* .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 10px;
  } */

  .add-title,
  .list-title{
    color: #333333;
    font-size: 24px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text p{
    font-size: 18px;
    line-height: 50px;
  
  }

  .MobelBox .write-text p.txt1{
    color: #18EF95;
  }

  .MobelBox .write-text p.txt2{
    color: #FF5156;
  }

  .MobelBox .write-text .answer-type{
    padding: 0 20px;
    border-radius: 6px;
    background-color: #F5F5F5;
    color: #999999;
    font-size: 18px;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }

  .MobelBox .write-text .answer-type.select{
    background-color: #6098F2;
    color: #fff;
  }

  .MobelBox .write-text .topicSelect{
    background-color: #D9E8FF;
    color: #6098F2;
    line-height: 40px;
  }

  .MobelBox .write-text video{
    width: 200px;
  }

  .write-content,
  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .write-content{
    overflow-y: auto;
    overflow-x: hidden;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-topic-create{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 18px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 50px;
  line-height: 50px;
  display: inline-block;
  margin-left: 20px;
}

.MobelBox .write-ai .write-text{
  width: auto;
}

.MobelBox>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.MobelBox>>> .el-radio{
  line-height: 50px;
}

.MobelBox>>> .el-radio__label{
  font-size: 18px;
}

.MobelBox>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-add,
.topic-title .btn-remove{
  font-size: 18px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.topic-title .btn-add{
  background-color: #F5F5F5;
  color: #999999;
  margin-left: 20px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.btn-topic-add{
  font-size: 16px;
  color: #6098F2;
  margin-top: 30px;
  display: block;  
  border: solid 1px #6098F2;
  border-radius: 6px;
  padding: 5px 15px;
  box-sizing: border-box;
}

.studentList .searchBox {
  padding: 0;
  margin-top: 25px;
  float: none;
}

.studentList .searchBox .search-item p{
  width: 80px;
  padding: 0;
}

.studentList .titleList{
  background-color: #F0F4FB;
  margin-top: 20px;
}

.studentList .dataList .listItem p,
.studentList .organiza-list p{
  width: calc( 100% / 3 );
}

.videoUpload{
  font-size: 0;
}

.videoUpload .weekTitle{
  font-size: 20px;
  position: relative;
  margin: 0 0 20px 45px;
}


.videoUpload .weekTitle::before{
  content: '';
  width: 5px;
  height: 18px;
  background-color: #6098F2;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0,-50%);
  transform: translate(0,-50%);
  left: -15px;
}

.videoUpload .video-item{
  padding: 0 70px;
  box-sizing: border-box;
  margin-top: 20px;
}

.IntentionallyBox .videoUpload .video-item .btn{
  font-size: 18px;
  color: #333333;
  border: solid 1px #333333;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 9px 20px;
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
}

.IntentionallyBox .videoUpload .video-item .btn.btn-topic-remove{
  background-color: #6098F2;
  color: #fff;
  border: solid 1px transparent;
}

.IntentionallyBox .videoUpload .video-item textarea{
  width: 430px;
  height: 112px;
  border: solid 1px #ECECEC;
  margin-left: 20px;
}

.IntentionallyBox .write-text{
  width: auto;
}

.videoUpload .btn-video-add{
  font-size: 18px;
  color: #fff;
  padding: 5px 20px;
  border-radius: 6px;
  background-color: #6098F2;
  margin-left: 20px;
}

.MobelBox.explainBox .write-text{
  width: auto;
}

/* .workBox */
.workBox .dataList .listItem p, 
.workBox .organiza-list p{
  width: calc( 100% / 11 );
  padding: 21px 10px;
}

.week-list{
  font-size: 0;
  display: block;
  margin-bottom: 20px;
}

.week-date{
  font-size: 0;
  margin-bottom: 30px;
}

.week-date p{
  color: #777777;
  font-size: 22px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
}

.week-date p.select{
  font-size: 26px;
  color: #333333;
  border-bottom: solid 4px #6098F2;
  padding-bottom: 6px;
}

.week-date span{
  font-size: 24px;
  color: #333333;
  margin-top: 20px;
  display: block;
}

.week-list .week-txt{
  font-size: 18px;
  color: #999999;
  box-sizing: border-box;
  padding: 0px 35px;
  border-radius: 6px;
  background-color: #F5F5F5;
  margin-right: 20px;
  display: inline-block;
  vertical-align: top;
}

.week-list .week-txt.select{
  background-color: #6098F2;
  color: #fff;
  padding: 0 25px;
  line-height: 40px;
}

.btn-play{
  width: 144px;
  height: 40px;
  color: #fff;
  background-color: #6098F2;
  border-radius: 6px;
  font-size: 18px;
}

.workExamBox .btn-play{

}

.wrong-title{
  font-size: 24px;
  color: #333333;
  margin-bottom: 20px;
}

.btn-choose{
  font-size: 18px;
  color: #fff;
  padding: 5px 20px;
  border-radius: 6px;
  background-color: #6098F2;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}

.big-topic-list{
  display: inline-block;
  vertical-align: top;
  width: 80%;
}

.topic-list p,
.big-topic-list p{
  display: inline-block;
  vertical-align: top;
  background-color: #F5F5F5;
  border-radius: 6px;
  margin-right: 20px;
  box-sizing: border-box;
  padding: 9px 25px;
  color: #999999;
  font-size: 18px;
}

.big-topic-list p.select{
  background-color: #6098F2;
  color: #fff;
}

.topic-list p.select{
  color: #6098F2;
  background-color: #D9E8FF;
  border: none;
}

.topic-list p{
  background-color: #fff;
  color: #6098F2;
  border: solid 1px #D9E8FF;
}

.topic-list{
  display: block;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/marketing/work.vue